import React from 'react';
import PropTypes from 'prop-types';
import withStyles from 'isomorphic-style-loader/lib/withStyles';
import cx from 'classnames';
import s from './TagButton.css';

const TagButton = ({ title, clickHandler, Icon, disabled, className, ...inputParams }) =>
  <div
    className={cx({
      [s.tag]: true,
      [s.disabled]: disabled,
      [className]: !!className,
    })}
    onClick={e => {
      clickHandler(e, title);
    }}
    {...inputParams}
  >
    {Icon ? <Icon /> : null}
    {title}
  </div>;

TagButton.propTypes = {
  title: PropTypes.string.isRequired,
  disabled: PropTypes.bool.isRequired,
  className: PropTypes.string,
  Icon: PropTypes.func,
  clickHandler: PropTypes.func,
};

TagButton.defaultProps = {
  disabled: false,
  className: '',
  Icon: null,
  clickHandler: () => {},
};

export default withStyles(s)(TagButton);



// WEBPACK FOOTER //
// ./src/shared/components/UI/TagButton/TagButton.js